/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Op_Enum, op_EnumFromJSON, op_EnumToJSON } from "../../../../util/protobuf_util/comparison_operator";

export const protobufPackage = "complimentary_actions";

export interface SpawnComplimentaryActionHook {
  /** Predicate spec evaluated on the GO_TO_WAYPOINT_STATUS_PB channel */
  waypointStatusHookSpec?: SpawnComplimentaryActionHook_WaypointStatusHookSpec | undefined;
}

/** Specification of a predicate evaluated on the GO_TO_WAYPOINT_STATUS_PB channel. */
export interface SpawnComplimentaryActionHook_WaypointStatusHookSpec {
  /** All of the conditions must be true */
  conditions: SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition[];
}

export interface SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition {
  progressCondition?: SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress | undefined;
  waypointNonceComparedToRegisteredUtime?:
    | SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime
    | undefined;
}

/** Waypoint progress (distance travelled / total distance) <comp> value */
export interface SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress {
  comp: Op_Enum;
  value: number;
}

/** Waypoint nonce <comp> utime that the spawn action was registered */
export interface SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime {
  comp: Op_Enum;
}

function createBaseSpawnComplimentaryActionHook(): SpawnComplimentaryActionHook {
  return { waypointStatusHookSpec: undefined };
}

export const SpawnComplimentaryActionHook = {
  encode(message: SpawnComplimentaryActionHook, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.waypointStatusHookSpec !== undefined) {
      SpawnComplimentaryActionHook_WaypointStatusHookSpec.encode(
        message.waypointStatusHookSpec,
        writer.uint32(10).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpawnComplimentaryActionHook {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpawnComplimentaryActionHook();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.waypointStatusHookSpec = SpawnComplimentaryActionHook_WaypointStatusHookSpec.decode(
            reader,
            reader.uint32(),
          );
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpawnComplimentaryActionHook {
    return {
      waypointStatusHookSpec: isSet(object.waypointStatusHookSpec)
        ? SpawnComplimentaryActionHook_WaypointStatusHookSpec.fromJSON(object.waypointStatusHookSpec)
        : undefined,
    };
  },

  toJSON(message: SpawnComplimentaryActionHook): unknown {
    const obj: any = {};
    if (message.waypointStatusHookSpec !== undefined) {
      obj.waypointStatusHookSpec = SpawnComplimentaryActionHook_WaypointStatusHookSpec.toJSON(
        message.waypointStatusHookSpec,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpawnComplimentaryActionHook>, I>>(base?: I): SpawnComplimentaryActionHook {
    return SpawnComplimentaryActionHook.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpawnComplimentaryActionHook>, I>>(object: I): SpawnComplimentaryActionHook {
    const message = createBaseSpawnComplimentaryActionHook();
    message.waypointStatusHookSpec =
      (object.waypointStatusHookSpec !== undefined && object.waypointStatusHookSpec !== null)
        ? SpawnComplimentaryActionHook_WaypointStatusHookSpec.fromPartial(object.waypointStatusHookSpec)
        : undefined;
    return message;
  },
};

function createBaseSpawnComplimentaryActionHook_WaypointStatusHookSpec(): SpawnComplimentaryActionHook_WaypointStatusHookSpec {
  return { conditions: [] };
}

export const SpawnComplimentaryActionHook_WaypointStatusHookSpec = {
  encode(
    message: SpawnComplimentaryActionHook_WaypointStatusHookSpec,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    for (const v of message.conditions) {
      SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpawnComplimentaryActionHook_WaypointStatusHookSpec {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpawnComplimentaryActionHook_WaypointStatusHookSpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.conditions.push(
            SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition.decode(reader, reader.uint32()),
          );
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpawnComplimentaryActionHook_WaypointStatusHookSpec {
    return {
      conditions: globalThis.Array.isArray(object?.conditions)
        ? object.conditions.map((e: any) => SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SpawnComplimentaryActionHook_WaypointStatusHookSpec): unknown {
    const obj: any = {};
    if (message.conditions?.length) {
      obj.conditions = message.conditions.map((e) =>
        SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpawnComplimentaryActionHook_WaypointStatusHookSpec>, I>>(
    base?: I,
  ): SpawnComplimentaryActionHook_WaypointStatusHookSpec {
    return SpawnComplimentaryActionHook_WaypointStatusHookSpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpawnComplimentaryActionHook_WaypointStatusHookSpec>, I>>(
    object: I,
  ): SpawnComplimentaryActionHook_WaypointStatusHookSpec {
    const message = createBaseSpawnComplimentaryActionHook_WaypointStatusHookSpec();
    message.conditions =
      object.conditions?.map((e) => SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition(): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition {
  return { progressCondition: undefined, waypointNonceComparedToRegisteredUtime: undefined };
}

export const SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition = {
  encode(
    message: SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.progressCondition !== undefined) {
      SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress.encode(
        message.progressCondition,
        writer.uint32(10).fork(),
      ).ldelim();
    }
    if (message.waypointNonceComparedToRegisteredUtime !== undefined) {
      SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime.encode(
        message.waypointNonceComparedToRegisteredUtime,
        writer.uint32(18).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.progressCondition = SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress.decode(
            reader,
            reader.uint32(),
          );
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.waypointNonceComparedToRegisteredUtime =
            SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime.decode(
              reader,
              reader.uint32(),
            );
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition {
    return {
      progressCondition: isSet(object.progressCondition)
        ? SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress.fromJSON(object.progressCondition)
        : undefined,
      waypointNonceComparedToRegisteredUtime: isSet(object.waypointNonceComparedToRegisteredUtime)
        ? SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime.fromJSON(
          object.waypointNonceComparedToRegisteredUtime,
        )
        : undefined,
    };
  },

  toJSON(message: SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition): unknown {
    const obj: any = {};
    if (message.progressCondition !== undefined) {
      obj.progressCondition = SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress.toJSON(
        message.progressCondition,
      );
    }
    if (message.waypointNonceComparedToRegisteredUtime !== undefined) {
      obj.waypointNonceComparedToRegisteredUtime =
        SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime.toJSON(
          message.waypointNonceComparedToRegisteredUtime,
        );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition>, I>>(
    base?: I,
  ): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition {
    return SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition>, I>>(
    object: I,
  ): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition {
    const message = createBaseSpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition();
    message.progressCondition = (object.progressCondition !== undefined && object.progressCondition !== null)
      ? SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress.fromPartial(object.progressCondition)
      : undefined;
    message.waypointNonceComparedToRegisteredUtime =
      (object.waypointNonceComparedToRegisteredUtime !== undefined &&
          object.waypointNonceComparedToRegisteredUtime !== null)
        ? SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime
          .fromPartial(object.waypointNonceComparedToRegisteredUtime)
        : undefined;
    return message;
  },
};

function createBaseSpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress(): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress {
  return { comp: 0, value: 0 };
}

export const SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress = {
  encode(
    message: SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.comp !== 0) {
      writer.uint32(8).int32(message.comp);
    }
    if (message.value !== 0) {
      writer.uint32(21).float(message.value);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.comp = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.value = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress {
    return {
      comp: isSet(object.comp) ? op_EnumFromJSON(object.comp) : 0,
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress): unknown {
    const obj: any = {};
    if (message.comp !== 0) {
      obj.comp = op_EnumToJSON(message.comp);
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress>, I>>(
    base?: I,
  ): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress {
    return SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress>, I>>(
    object: I,
  ): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress {
    const message = createBaseSpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_Progress();
    message.comp = object.comp ?? 0;
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseSpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime(): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime {
  return { comp: 0 };
}

export const SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime = {
  encode(
    message: SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.comp !== 0) {
      writer.uint32(8).int32(message.comp);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message =
      createBaseSpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.comp = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(
    object: any,
  ): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime {
    return { comp: isSet(object.comp) ? op_EnumFromJSON(object.comp) : 0 };
  },

  toJSON(
    message: SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime,
  ): unknown {
    const obj: any = {};
    if (message.comp !== 0) {
      obj.comp = op_EnumToJSON(message.comp);
    }
    return obj;
  },

  create<
    I extends Exact<
      DeepPartial<SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime>,
      I
    >,
  >(base?: I): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime {
    return SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime
      .fromPartial(base ?? ({} as any));
  },
  fromPartial<
    I extends Exact<
      DeepPartial<SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime>,
      I
    >,
  >(object: I): SpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime {
    const message =
      createBaseSpawnComplimentaryActionHook_WaypointStatusHookSpec_Condition_WaypointNonceComparedToRegisteredUtime();
    message.comp = object.comp ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
